import CookieIcon from "@mui/icons-material/Cookie";
import { Box, Container, Link, Paper, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { FUNCTIONAL_COOKIES, NECESSARY_COOKIES } from "../../constants/global";
import { ContentfulContext } from "../../context/ContentfulContext";
// import { RecaptchaContext } from "../../context/RecaptchaContext";
import { Cookies } from "../../models/schema";
import { getItem, removeFunctionalItems, setItem } from "../../utils/storage";
import Button, { ButtonVariant } from "../utils/Button";
import ButtonContainer from "../utils/ButtonContainer";
import RenderContent from "../utils/RenderContent";

const CookieConsent = () => {
  const [neccessaryCookies, setNeccessaryCookies] = useState<boolean>(getItem(NECESSARY_COOKIES));

  // const { setNeccessaryCookiesAllowed } = useContext(RecaptchaContext);

  const [open, setOpen] = useState<boolean>(!neccessaryCookies);

  const { content } = useContext(ContentfulContext);
  const { title, description, allowAll, allowNeccessary, close } = content.cookieBanner as Cookies;

  return (
    <>
      <Link
        underline="hover"
        sx={{
          cursor: "pointer",
          color: "inherit",
          fontSize: { xs: "0.69rem", md: "0.83rem" }
        }}
        onClick={() => setOpen(true)}>
        {title}
      </Link>

      {open && (
        <Box
          sx={{
            position: "fixed",
            zIndex: 1000,
            bottom: 0,
            left: 0,
            width: "100%"
          }}>
          <Container maxWidth="xl" sx={{ p: { xs: 0 } }}>
            <Paper
              sx={{
                width: "100%",
                overflowY: "auto",
                boxShadow: "1px -5px 4px 0px rgba(0, 0, 0, 0.25)",
                p: 4,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
              }}>
              <Typography
                variant="h5"
                fontWeight="bold"
                mb={{ xs: 2, lg: 4 }}
                sx={{ display: "flex", alignItems: "center" }}>
                <CookieIcon fontSize="large" sx={{ mr: 3 }} />
                {title}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", lg: "row" },
                  justifyContent: { xs: "center", lg: "space-between" }
                }}>
                <RenderContent content={description?.json} />
                <ButtonContainer sx={{ mt: { xs: 3, lg: 0 }, ml: { xs: 0, lg: 5 } }}>
                  <Button
                    onClick={() => {
                      setItem(NECESSARY_COOKIES, true);
                      setItem(FUNCTIONAL_COOKIES, true);
                      setNeccessaryCookies(true);
                      // setNeccessaryCookiesAllowed(true);
                      setOpen(false);
                    }}
                    label={allowAll as string}
                    variant={ButtonVariant.primary}
                  />
                  <Button
                    onClick={() => {
                      setNeccessaryCookies(true);
                      setItem(FUNCTIONAL_COOKIES, false);
                      setItem(NECESSARY_COOKIES, true);
                      // setNeccessaryCookiesAllowed(true);
                      removeFunctionalItems();
                      setOpen(false);
                    }}
                    label={allowNeccessary as string}
                    variant={ButtonVariant.secondary}
                  />
                  {neccessaryCookies && (
                    <Button
                      onClick={() => {
                        setOpen(false);
                      }}
                      label={close as string}
                      variant={ButtonVariant.secondary}
                    />
                  )}
                </ButtonContainer>
              </Box>
            </Paper>
          </Container>
        </Box>
      )}
    </>
  );
};

export default CookieConsent;
